import { ChecklistFormData } from "features/CenterContent/RoleContent/VehicleChecklist/schema/formSchema";
import { FilloutRequest } from "features/CenterContent/RoleContent/VehicleChecklist/schema/requestSchema";
import { RollingStockType } from "features/CenterContent/RoleContent/VehicleChecklist/utils";
import { dateTimeFormToRequest } from "shared/form/dateTimeSchema";

export const FilloutFormToRequest = (
  data: ChecklistFormData,
): FilloutRequest => {
  const checklistData: FilloutRequest = {
    companyId: data.trainOwner,
    executor: data.executor,
    rollingStockId: data.rollingStockId,
    rollingStockType: RollingStockType.VEHICLE_SET,
    executedAt: dateTimeFormToRequest(data.dateTime),
    checklistType: data.fillOutType,
    vehicleType: data.vehicleType,
    comment: data.comment,
  };

  return checklistData;
};
